import { FileElement } from "./file-element";

export class FileExplorerOut {
    fileElement:FileElement;
    index:number;
}
